<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

  @if (rate) {
    <app-page-detail-hero [auditStamp]="rate"
      icon="pi pi-money-bill"
      eyebrow="Storage Rate"
      [title]="chargeTypeLabel(rate.chargeType || rate.metric) + ' Rate'"
      [subtitle]="clientName(rate.crmClientId) + ' | ' + masterName('WAREHOUSE', rate.warehouseId)">
      <div tags>
        <p-tag [value]="rate.isActive ? 'ACTIVE' : 'INACTIVE'" [severity]="statusSeverity(rate.isActive ? 'ACTIVE' : 'INACTIVE')"></p-tag>
        <p-tag [value]="chargeTypeLabel(rate.chargeType || rate.metric)" severity="info"></p-tag>
        <p-tag *ngIf="rate.chargeUnit" [value]="chargeUnitLabel(rate.chargeUnit)" severity="success"></p-tag>
        <p-tag [value]="rate.currency || 'SAR'" severity="secondary"></p-tag>
      </div>
      <div actions>
        <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/warehousing/setup/storage-rates"></p-button>
        <p-button label="Edit" icon="pi pi-pencil" severity="info" [routerLink]="['/warehousing/setup/storage-rates/edit', rate.id]"></p-button>
      </div>
    </app-page-detail-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <div class="warehousing-detail-grid">
      <app-page-form-section icon="pi pi-building" title="Customer Scope" subtitle="Client, account, and storage location this rate applies to.">
        <div class="warehousing-detail-list">
          <div><span>Client</span><strong>{{ clientName(rate.crmClientId) }}</strong></div>
          <div><span>Account</span><strong>{{ accountName(rate.crmAccountId) }}</strong></div>
          <div><span>Region</span><strong>{{ masterName('REGION', rate.regionId) }}</strong></div>
          <div><span>Warehouse</span><strong>{{ masterName('WAREHOUSE', rate.warehouseId) }}</strong></div>
        </div>
      </app-page-form-section>

      <app-page-form-section icon="pi pi-calculator" title="Rate Details" subtitle="Effective charge type and warehouse price.">
        <div class="warehousing-detail-list">
          <div><span>Charge Type</span><strong>{{ chargeTypeLabel(rate.chargeType || rate.metric) }}</strong></div>
          <div><span>Charge Unit</span><strong>{{ chargeUnitLabel(rate.chargeUnit) }}</strong></div>
          <div><span>Rate</span><strong>{{ rate.ratePerDay | number:'1.2-4' }} {{ rate.currency }}</strong></div>
          <div><span>Effective From</span><strong>{{ rate.effectiveFrom || '-' }}</strong></div>
          <div><span>Effective To</span><strong>{{ rate.effectiveTo || '-' }}</strong></div>
        </div>
      </app-page-form-section>
    </div>
  } @else if (!isLoading) {
    <div class="warehousing-empty-detail">
      <i class="pi pi-search"></i>
      <strong>Storage rate not found</strong>
      <span>The selected storage rate could not be loaded.</span>
    </div>
  }
</app-page-shell>
